import { DefaultSidebar, Sidebar } from "@excalidraw/excalidraw";
import { messageCircleIcon } from "@excalidraw/excalidraw/components/icons";
import { useUIAppState } from "@excalidraw/excalidraw/context/ui-appState";

import { CommentsPanel } from "../comments/CommentsPanel";
import {
  DocumentsPanel,
  documentsSidebarTabIcon,
} from "../documents/DocumentsPanel";

export const AppSidebar = () => {
  const { openSidebar } = useUIAppState();

  return (
    <DefaultSidebar>
      <DefaultSidebar.TabTriggers>
        <Sidebar.TabTrigger
          tab="documents"
          title="Documents"
          style={{ opacity: openSidebar?.tab === "documents" ? 1 : 0.4 }}
        >
          {documentsSidebarTabIcon}
        </Sidebar.TabTrigger>
        <Sidebar.TabTrigger
          tab="comments"
          title="Comments"
          style={{ opacity: openSidebar?.tab === "comments" ? 1 : 0.4 }}
        >
          {messageCircleIcon}
        </Sidebar.TabTrigger>
      </DefaultSidebar.TabTriggers>
      <Sidebar.Tab tab="documents">
        <DocumentsPanel />
      </Sidebar.Tab>
      <Sidebar.Tab tab="comments">
        <CommentsPanel />
      </Sidebar.Tab>
    </DefaultSidebar>
  );
};
